import React from "react";
import styled from "styled-components";
// import common components
import Typography, { TYPE_ELEMENTS } from "./Typography";
// imoport constants
import CONSTANTS from "../utils/constants/constants";
// import assets
import triangleArrowRight from "../assets/icons/triangle-arrow-right.svg";

const MoreInfoLink = styled.div`
  display: ${(props) => props.display};
  align-items: center;
  gap: 8px;
  cursor: pointer;

  &:hover {
    color: white;
    img {
      transform: translateX(4px);
      transition: transform 0.3s ease-in-out;
    }
  }
`;

const Arrow = styled.img`
  transform: ${(props) =>
    props.rotate === "true" ? "rotate(90deg)" : "rotate(0deg)"};
`;

export default function MoreInfoElement({ linkText, infoVisible = false, isInline = false }) {
  return (
    <MoreInfoLink display={isInline ? "inline-flex" : "flex"}>
      <Typography typeElement={TYPE_ELEMENTS.SUBTITLE_2}>
        {!infoVisible ? linkText : CONSTANTS.HIDE}
      </Typography>
      <Arrow
        rotate={`${infoVisible}`}
        src={triangleArrowRight}
        alt="triangle arrow left"
      />
    </MoreInfoLink>
  );
}
